// extracted by mini-css-extract-plugin
export default {"-large":"connect-to-facebook-module__-large--VO4xR","fbLogoContainer":"connect-to-facebook-module__fbLogoContainer--zY4mo","text":"connect-to-facebook-module__text--XPJy0"};